import { Controller } from "stimulus"

var delayTimer;
export default class extends Controller {

    connect() {
        // Defer setting _ready so that any change events fired synchronously
        // during sibling controller initialization (e.g. flatpickr dispatches
        // a "change" event when it parses the input's default value) are
        // ignored.  Without this guard the page enters an infinite reload
        // loop: flatpickr init → change → updateReport → navigate → repeat.
        this._ready = false;
        setTimeout(() => { this._ready = true; }, 0);
    }

    updateReport(e) {
        if (!this._ready) return;

        clearTimeout(delayTimer);
        delayTimer = setTimeout(() => {
            const asOfDate = document.getElementById("as_of_date")
            const fundIds = document.getElementById("fund_ids")
            const trialBalanceType = document.getElementById("trial_balance_type")

            if (asOfDate.value != "") {
                document.getElementById("flash-area").innerHTML = ""

                // Get selected fund IDs
                let selectedFunds = [];
                if (fundIds && fundIds.selectedOptions) {
                    for (let option of fundIds.selectedOptions) {
                        if (option.value) selectedFunds.push(option.value);
                    }
                }

                // Build title
                let title = `${trialBalanceType.value === 'preclosing' ? 'Preclosing' : 'Regular'} Trial Balance: As of ${asOfDate.value}`;

                // Build report URL with parameters
                let reportUrl = 'chart?title=' + encodeURIComponent(title) +
                    '&data_source=reports_trial_balance_path' +
                    '&as_of_date=' + asOfDate.value +
                    '&trial_balance_type=' + trialBalanceType.value;

                // Add fund IDs if selected
                if (selectedFunds.length > 0) {
                    selectedFunds.forEach(fundId => {
                        reportUrl += '&fund_ids[]=' + fundId;
                    });
                }

                // Only navigate if the URL actually changed
                if (window.location.search !== '?' + reportUrl.split('?')[1]) {
                    window.location.href = reportUrl;
                }
            } else {
                document.getElementById("flash-area").innerHTML = ('<div class="warn">Please select an as of date.</div>')
                asOfDate.classList.add('required-field')
            }

        }, 2500)
    }
}
